import selectSubsetTemplate from './select-subset.html';

export function SelectSubset() {
    return {
        link: (scope) => {
            if (
                scope.subsets &&
                scope.subsets.constructor === Array &&
                typeof scope.subsets[0] === 'object'
            ) {
                scope.subsets = scope.subsets
                    .map((subset) => {
                        const label = Object.keys(subset)[0];
                        subset[label].label = label;
                        return subset[label];
                    })
                    .filter((subset) => subset.hidden === false);
            }
            scope.selectedSubsets = scope.selectedSubsets || {
                custom: '',
                subsets: [],
            };
            scope.toggleSubset = (subset) => {
                const selectedSubset = subset.label || subset;
                const subsetIndex =
                    scope.selectedSubsets.subsets.indexOf(selectedSubset);
                if (subsetIndex !== -1) {
                    scope.selectedSubsets.subsets.splice(subsetIndex, 1);
                    return;
                }
                scope.selectedSubsets.subsets.push(selectedSubset);
            };
        },
        scope: {
            selectedSubsets: '=?',
            subsets: '<',
        },
        restrict: 'E',
        template: selectSubsetTemplate,
        transclude: true,
    };
}
